import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { Tabs } from '../../../ds/components';
import styles from './header.module.css';

export type TicketsTab = 'board' | 'mailbox' | 'after-sales';

const tabPaths: Record<TicketsTab, string> = {
  board: '/tickets',
  mailbox: '/tickets/mailbox',
  'after-sales': '/tickets/after-sales',
};

const tabItems: ReadonlyArray<{ value: TicketsTab; label: string }> = [
  { value: 'board', label: 'Board' },
  { value: 'mailbox', label: 'Postfach' },
  { value: 'after-sales', label: 'After-Sales' },
];

export interface TicketsHeaderProps {
  /** „Backoffice" (board) or „Tickets" (Postfach, After-Sales). */
  eyebrow: string;
  title: string;
  /** The API's line („Support-Postfach … · 11 offen"); omitted while loading. */
  line?: string | null | undefined;
  actions?: ReactNode | undefined;
  tab: TicketsTab;
}

/**
 * Head of the three ticket tabs (Backoffice 03/04, After-Sales 01–03): eyebrow, H1, count line, the actions on the
 * right and the tab bar „Board · Postfach · After-Sales" (A2 Unterreiter, each tab is its own route).
 */
export function TicketsHeader({ eyebrow, title, line, actions, tab }: TicketsHeaderProps) {
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.head}>
        <div className={styles.headText}>
          <div className={styles.eyebrow}>{eyebrow}</div>
          <h1 className={styles.title}>{title}</h1>
          {line ? <div className={styles.line}>{line}</div> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
      <Tabs
        label="Tickets"
        items={tabItems}
        value={tab}
        onChange={(next) => {
          if (next !== tab) void navigate(tabPaths[next]);
        }}
        className={styles.tabs}
      />
    </>
  );
}
